import { Reveal } from "@/components/motion/Reveal";
import { ButtonLink } from "@/components/common/ButtonLink";
import { WhatsAppIcon } from "@/components/common/WhatsAppIcon";
import { whatsappLink } from "@/lib/whatsapp";
import { home } from "@/content/site";
import { noStop } from "@/components/common/SectionHeader";

// Full-bleed accent band with the primary call to action.
export const CtaBand = ({ title = home.cta.title, body = home.cta.body, button = home.cta.button, to = "/contact" }) => (
  <section className="container-x pb-24 sm:pb-32" data-testid="cta-band">
    <Reveal className="spec-corners relative overflow-hidden bg-accent px-6 py-16 text-accent-ink sm:px-12 sm:py-20 lg:px-20 lg:py-24">
      <div className="pointer-events-none absolute inset-0 opacity-[0.12] [background-image:linear-gradient(currentColor_1px,transparent_1px),linear-gradient(90deg,currentColor_1px,transparent_1px)] [background-size:48px_48px]" aria-hidden="true" />
      <div className="relative max-w-3xl">
        <h2 className="font-display text-4xl font-semibold leading-[1.04] tracking-[-0.04em] sm:text-5xl lg:text-6xl">{noStop(title)}</h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed opacity-90 sm:text-lg">{body}</p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <ButtonLink to={to} variant="light" testId="cta-band-button">
            {button}
          </ButtonLink>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-none border border-accent-ink/40 px-5 py-3.5 text-[15px] font-semibold transition-colors duration-300 hover:bg-black/15"
            data-testid="cta-band-whatsapp"
          >
            <WhatsAppIcon className="h-5 w-5" /> Message on WhatsApp
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
